module.exports = __webpack_public_path__ + "static/media/arrow-down.bf1dcd42.svg";